<template>
  <b-nav-item-dropdown
    class="dropdown-cart mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
        <transition name="shake" mode="out-in">
            <feather-icon
                :key="cartItemsCount"
                size="21"
                class="text-body"
                icon="ShoppingCartIcon"
                :badge="cartItemsCount"
            />
        </transition>
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          My Cart
        </h4>
        <b-badge
          pill
          variant="light-primary"
        >
          {{ cartItemsCount }} Items
        </b-badge>
      </div>
    </li>

    <!-- Cart Items -->
    <vue-perfect-scrollbar
      v-if="items.length"
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <b-media
        v-for="item in items"
        :key="item.name"
      >
        <div class="media-heading">
          <h6 class="cart-item-title">
            <b-link class="text-body">
              {{ item.name }}
            </b-link>
          </h6>
        </div>

        <h5 class="cart-item-price">
            {{ formatPrice(item.price) }}
        </h5>
      </b-media>

      <b-media v-if="signupDiscount">
          <div class="media-heading">
              <h6 class="cart-item-title">
                  <b-link class="text-body">
                    {{ signupDiscount.name }}
                  </b-link>
              </h6>
          </div>

          <h5 class="cart-item-price">
              ({{ formatPrice(signupDiscount.price)  }})
          </h5>
      </b-media>
    </vue-perfect-scrollbar>

    <!-- Cart Footer -->
    <li
      v-if="items.length"
      class="dropdown-menu-footer"
    >
      <div class="d-flex justify-content-between mb-1">
        <h6 class="font-weight-bolder mb-0">
          Total:
        </h6>
        <h6 class="text-primary font-weight-bolder mb-0">
          ${{ totalAmount.toLocaleString() }}
        </h6>
      </div>
    </li>

    <div v-if="!items.length" class="d-flex justify-content-center flex-column align-items-center p-3">
        <img src="/illustrations/empty-cart.svg" alt="Empty Cart">
        <hr>
        <p
            class="text-center"
        >
            Your cart is empty
        </p>
    </div>
  </b-nav-item-dropdown>
</template>

<script>
import {
    BNavItemDropdown, BBadge, BMedia, BLink,
} from 'bootstrap-vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Ripple from 'vue-ripple-directive';
import { mapGetters } from "vuex";
import { getSignupDiscount } from '@/apis/company';
import { formatPrice } from '@/helpers';

export default {
    components: {
        BNavItemDropdown,
        BBadge,
        BMedia,
        BLink,
        // BFormSpinbutton,
        VuePerfectScrollbar,
        // BButton,
    },

    directives: {
        Ripple,
    },

    data() {
        return {
            perfectScrollbarSettings: {
                maxScrollbarLength: 60,
                wheelPropagation: false,
            },
            signupDiscount: null
        };
    },

    computed: {
        ...mapGetters({
            cartItemsCount: "cart/getItemsCount",
            items: "cart/getItems",
        }),

        totalAmount() {
            let total = 0;
            this.items.forEach(i => { total += i.price; });

            if(this.signupDiscount)
            {
                total -= parseFloat(this.signupDiscount.price);
            }
            
            return total;
        }, 
    },

    mounted()
    {
        getSignupDiscount().then(response => {
            this.signupDiscount = response;
        }).catch(e => console.log('error in cart', e));
    },
    
    methods: {
        removeItemFromCart(productId) {
            this.$store.dispatch('app-ecommerce/removeProductFromCart', { productId })
                .then(() => {
                    const itemIndex = this.items.findIndex(p => p.id === productId);
                    this.items.splice(itemIndex, 1);

                    // Update count in cart items state
                    this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', this.items.length);
                });
        },

        formatPrice(price) {
            return formatPrice(price);
        }
    }
};
</script>

<style lang="scss" scoped>
.dropdown-cart {
  .media {
    .media-aside {
      align-items: center;
    }
  }
}

.shake-enter-active,
.shake-leave-active {
    animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
    transition: all .3s ease;
}

.shake-enter,
.shake-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
    animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
    transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
}

.header-navbar .navbar-container ul.navbar-nav li.dropdown-cart .cart-item-price {
  width: 6rem;
}

@keyframes shake {
    10%, 90% {
        transform: translate3d(-1px, 0, 0);
    }

    20%, 80% {
        transform: translate3d(2px, 0, 0);
    }

    30%, 50%, 70% {
        transform: translate3d(-3px, 0, 0);
    }

    40%, 60% {
        transform: translate3d(3px, 0, 0);
    }
}

.media-heading
{
    width: 100% !important;
}
</style>